import React from 'react';
import { Box, Container, Typography, Divider, Link } from '@mui/material';

export default function CookiePolicy() {

  return (
    <Box sx={{ bgcolor: '#ffffff', minHeight: '100vh', py: 6 }}>
      <Container maxWidth="md">
        {/* Header */}
        <Typography variant="h3" sx={{ fontWeight: 700, mb: 2, color: '#111827' }}>
          Cookie Policy
        </Typography>
        <Typography variant="body2" sx={{ color: '#6b7280', mb: 4 }}>
          Last Updated: October 2025
        </Typography>

        <Divider sx={{ mb: 4 }} />

        {/* Introduction */}
        <Typography variant="body1" sx={{ color: '#374151', mb: 4, lineHeight: 1.8 }}>
          Sniffr.ai uses cookies and similar technologies to enhance your browsing experience, analyze 
          website traffic, and improve our services.
        </Typography>

        <Typography variant="body1" sx={{ color: '#374151', mb: 4, lineHeight: 1.8 }}>
          Cookies are small text files placed on your device to help us understand user behavior, remember 
          preferences, and deliver a more personalized experience.
        </Typography>

        {/* Types of Cookies */}
        <Typography variant="h5" sx={{ fontWeight: 600, mb: 2, color: '#1f2937' }}>
          Types of Cookies We Use:
        </Typography>
        
        <Typography variant="body1" sx={{ color: '#374151', mb: 2, lineHeight: 1.8 }}>
          <strong>Essential Cookies:</strong> Required for website functionality.
        </Typography>

        <Typography variant="body1" sx={{ color: '#374151', mb: 2, lineHeight: 1.8 }}>
          <strong>Analytics Cookies:</strong> Used to collect anonymous usage data via tools like Google Analytics.
        </Typography>

        <Typography variant="body1" sx={{ color: '#374151', mb: 4, lineHeight: 1.8 }}>
          <strong>Preference Cookies:</strong> Remember your language or region settings.
        </Typography>

        {/* Managing Cookies */}
        <Typography variant="body1" sx={{ color: '#374151', mb: 4, lineHeight: 1.8 }}>
          You can manage or disable cookies through your browser settings at any time. However, please note 
          that disabling certain cookies may affect website performance or functionality.
        </Typography>

        <Typography variant="body1" sx={{ color: '#374151', mb: 4, lineHeight: 1.8 }}>
          For more information about how we handle your data, please see our <Link href="/privacy-policy" sx={{ color: '#3b82f6', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}>Privacy Policy</Link>.
        </Typography>

        {/* Contact */}
        <Typography variant="body1" sx={{ color: '#374151', mb: 4, lineHeight: 1.8 }}>
          <strong>Contact:</strong> support@sniffr.ai
        </Typography>

        <Divider sx={{ my: 4 }} />

        <Typography variant="body2" sx={{ color: '#6b7280', textAlign: 'center' }}>
          © 2025 Sniffr.ai. All rights reserved.
        </Typography>
      </Container>
    </Box>
  );
}

